$(document).ready(function() {

  $("li.hover_mega_menu > a").click(function(e) {
    e.preventDefault();
    console.log("hello World");
    if($(this).parent('.hover_mega_menu').hasClass("hover")){
      $(this).parent('.hover_mega_menu').removeClass("hover");
    }else{
      $(".hover_mega_menu").removeClass("hover");
      $(this).parent('.hover_mega_menu').addClass("hover");
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.desktop-megamenu').length && !$(event.target).closest('li.hover_mega_menu, li.hover_mega_menu *').length) {
      // console.log("ok");
      $(".hover_mega_menu").removeClass("hover");
    }
  });

  $('.js-toggle-submenu-two').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next().slideToggle('500');
  });   
  // --------------------- Menu drop down
  
  // Search
  function open_search(){
    $(".search_model-bar").show();
    $('.header__search-model').addClass('open-model');
    $("#Search-In-Modal").trigger("focus");
  }
  
  function close_search(){
    $(".search_model-bar").hide();
    $('.header__search-model').removeClass('open-model');
    $('.search_toggle_button').removeClass('active');
  }

  $('body').click(function () {
    close_search();
  });
  $('.site-header .header__search,#menu-drawer-search').click(function(e) {
    e.stopPropagation();
  })

  $('.search_toggle_button').click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      open_search();
    }else{
      close_search();
    }
  });
  $('.search_model-close').click(function(){
      close_search();
  });
  
  $("#Search-In-Modal").on("click", function() {
    setTimeout(open_search(),200);
    $('.site-nav__item--has-dropdown').removeClass('hover')
  });
  $(".search_model-bar .search_model-overlay").on("click", function() {
    close_search();
  });

  $('#Search-In-Modal').keyup(function() {
    var form = $(this).parents('form').serialize(); 
    fetch(`/search?${form}&section_id=header`).then(responseText => responseText.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      $('.search_model-bar .search_model-container').html($(html).find('.search_model-bar .search_model-container').html())
    });
  });

  $('#menu-drawer-search').click(function(){
    $('.slide-nav__overflow.js-menu--is-open .js-toggle-slide-nav').click();
    setTimeout(open_search(),200);
  }); 
  // --------------------- Search

  // Product page afterpay klarna popup
  $('.instalment-payment .instalment-payment-block').click(function() {
    var popup = $(this).data('title');
    $('.instalment-payment .'+popup).addClass('active');
  });
  $('.instalment-payment-popup .close,.instalment-payment-popup .instalment-payment-popup-overlay').click(function() {
    $(this).parents('.instalment-payment-popup').removeClass('active');
  });
 // --------------------- Product page afterpay klarna popup

  // Product Page Size popup
  $('#size-fit-popup-toggle,#size-fit-popup .size-fit-popup-overlayer,#size-fit-popup .close-size-fit').click(function() {
    $('#size-fit-popup').toggleClass('active');
  });
  // --------------------- Product Page Size popup

  $(document).on('change','.grid-product__content .product-grid-form .grid-product__colors input',function() {
    var id = $(this).data('id');
    var select_img = $(this).parents('.grid-product__content').find('.grid-product-variant-img img[data-id="'+id+'"]');
    if(select_img != ''){
      $(this).parents('.grid-product__content').find('.grid-product-variant-img img').removeClass('active');
      $(this).parents('.grid-product__content').find('.grid-product-variant-img').addClass('active');
      select_img.addClass('active');
    }
  });
  

  // Product grid form submit
  $(document).on('change','.grid-product__content .product-grid-form .select-wrap select',function() {
    var select = $(this)
    var val = $(this).val();
    var arr = [];
    if(val != 'default'){
      $(this).parents('.product-grid-form').find('.grip-product--option').each(function() {
        if($(this).find('input').length){
          arr.push($(this).find('input:checked').val());
        }else{
          arr.push($(this).find('select').val());
        }
      });
      arr = arr.join(' / ');
      var id = $(this).parents('.product-grid-form').find('[data-product-select] option[data-title="'+arr+'"]').val();
      $(this).parents('.product-grid-form').find('[data-product-select]').val(id).change();
      if($(this).parents('.product-grid-form').find('[data-product-select] option[data-title="'+arr+'"]').is(':disabled')){ 
        $(this).parents('.product-grid-form').find('.not-available').removeClass('hide');
        setTimeout(function(){$('.product-grid-form .not-available').addClass('hide');},1500);
      }else{
        $(this).parents('.product-grid-form').find('[data-add-to-cart]').click();
        setTimeout(function(){
          try {
            if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.status === 'ready' && typeof window.Rebuy.SmartCart.show === 'function') {
              window.Rebuy.SmartCart.show();
            }
          } catch (err) {}
        },1200);
      }
      setTimeout(function(){select.val('default').trigger('change');},1000);
    }
  });

  $(document).on('submit','.grid-product__content .product-grid-form form',function(e) {
    e.preventDefault();
    let formData = $(this).serialize();
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      // 422 (sold out, quantity limit, ...): nothing was added, so do not open anything
      if (!response.ok) { return null; }
      return response.json();
    })
    .then(function (data) {
      // Added: open the Rebuy cart, or the cart page if Rebuy is missing or late
      if (data && window.TJNCart) { window.TJNCart.afterAdd(); }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  // --------------------- Product grid form submit


  // product page mobile size selector
  if($('.select-size-drop-down-menu-wrap').length > 0){
    $(document).on('change','.select-size-drop-down-menu-wrap #select-size-drop-down-menu',function(){
      var val = $(this).val();
      $(this).parents('.select-size-drop-down-menu-wrap').next('.variant-input-wrap').find('input[value="'+ val +'"]').next('label').click();
      console.log(val);
    });
  }


  // --------------- fit finer

  function openCity(cityName) {
    var i;
    var x = document.getElementsByClassName("city");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    document.getElementById(cityName).style.display = "block";
  }

  // product page popup js

  $(".find_fit-toggle,.modal-close,#modal-find-your-fit, #form-button-continue").click(function (e) {
      e.preventDefault();
      $("#modal-find-your-fit").toggleClass("active");
  });

    $("#modal-find-your-fit .modal-dialog").click(function(e){
    e.stopPropagation();
  });
  
  $('.desktop-megamenu').click(function(event){
      if (event.target === this) {
          $(this).parents('.site-nav__item').removeClass('hover');
      }
  });



  setInterval(function () {
  var selectedSize   = $('.select-size-drop-down-menu').val()?.trim();
  var selectedColor  = $('fieldset[name="Color"] input[type="radio"]:checked').val()?.trim();
  var selectedOption = $('fieldset[name="Customize Option"] input[type="radio"]:checked').val()?.trim();

  // -------------------- 3 ATTRIBUTE CASES --------------------
  if (selectedSize && selectedColor && selectedOption) {
    var triples = [];

    $('[data-product-select] option').each(function () {
      if (!$(this).is(':disabled')) {
        var a = $(this).attr('data-var1')?.trim(); // Color
        var b = $(this).attr('data-var2')?.trim(); // Size
        var c = $(this).attr('data-var3')?.trim(); // Customize
        if (a != null && b != null && c != null) {
          // push all 6 permutations so order doesn’t matter
          triples.push([a,b,c],[a,c,b],[b,a,c],[b,c,a],[c,a,b],[c,b,a]);
        }
      }
    });

    // --- Size options (needs [size, selectedColor, selectedOption]) ---
    $('.select-size-drop-down-menu option, .tolstoy-select-size-drop-down-menu option').each(function () {
      var size = $(this).val()?.trim();
      var ok = triples.some(function(t){ return t[0]===size && t[1]===selectedColor && t[2]===selectedOption; });
      if (ok) $(this).prop('disabled', false);
      else if (size !== selectedSize) $(this).prop('disabled', true);
    });

    // --- Color radios (needs [selectedSize, color, selectedOption]) ---
    $('fieldset[name="Color"] input[type="radio"]').each(function () {
      var color = $(this).val()?.trim();
      var ok = triples.some(function(t){ return t[0]===selectedSize && t[1]===color && t[2]===selectedOption; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (color !== selectedColor) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });

    // --- Customize radios (needs [selectedSize, selectedColor, customize]) ---
    $('fieldset[name="Customize Option"] input[type="radio"]').each(function () {
      var opt = $(this).val()?.trim();
      var ok = triples.some(function(t){ return t[0]===selectedSize && t[1]===selectedColor && t[2]===opt; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (opt !== selectedOption) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });
  }

  // -------------------- 2 ATTRIBUTE CASES --------------------
  else if (selectedSize && selectedColor) {
    // Size + Color (and Color + Size)
    var pairs = [];
    $('[data-product-select] option').each(function(){
      if (!$(this).is(':disabled')) {
        var a=$(this).attr('data-var1')?.trim(), b=$(this).attr('data-var2')?.trim(), c=$(this).attr('data-var3')?.trim();
        pairs.push([a,b],[b,a],[a,c],[c,a],[b,c],[c,b]);
      }
    });

    // Size dropdown by [size, selectedColor]
    $('.select-size-drop-down-menu option, .tolstoy-select-size-drop-down-menu option').each(function(){
      var size=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===size && p[1]===selectedColor; });
      if (ok) $(this).prop('disabled', false);
      else if (size!==selectedSize) $(this).prop('disabled', true);
    });

    // Color radios by [selectedSize, color]
    $('fieldset[name="Color"] input[type="radio"]').each(function(){
      var color=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===selectedSize && p[1]===color; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (color!==selectedColor) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });
  }

  else if (selectedSize && selectedOption) {
    // Size + Customize (and Customize + Size)
    var pairs = [];
    $('[data-product-select] option').each(function(){
      if (!$(this).is(':disabled')) {
        var a=$(this).attr('data-var1')?.trim(), b=$(this).attr('data-var2')?.trim(), c=$(this).attr('data-var3')?.trim();
        pairs.push([a,b],[b,a],[a,c],[c,a],[b,c],[c,b]);
      }
    });

    // Size dropdown by [size, selectedOption]
    $('.select-size-drop-down-menu option, .tolstoy-select-size-drop-down-menu option').each(function(){
      var size=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===size && p[1]===selectedOption; });
      if (ok) $(this).prop('disabled', false);
      else if (size!==selectedSize) $(this).prop('disabled', true);
    });

    // Customize radios by [selectedSize, opt]
    $('fieldset[name="Customize Option"] input[type="radio"]').each(function(){
      var opt=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===selectedSize && p[1]===opt; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (opt!==selectedOption) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });
  }

  else if (selectedColor && selectedOption) {
    // Color + Customize (and Customize + Color)
    var pairs = [];
    $('[data-product-select] option').each(function(){
      if (!$(this).is(':disabled')) {
        var a=$(this).attr('data-var1')?.trim(), b=$(this).attr('data-var2')?.trim(), c=$(this).attr('data-var3')?.trim();
        pairs.push([a,b],[b,a],[a,c],[c,a],[b,c],[c,b]);
      }
    });

    // Color radios by [color, selectedOption]
    $('fieldset[name="Color"] input[type="radio"]').each(function(){
      var color=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===color && p[1]===selectedOption; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (color!==selectedColor) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });

    // Customize radios by [selectedColor, opt]
    $('fieldset[name="Customize Option"] input[type="radio"]').each(function(){
      var opt=$(this).val()?.trim();
      var ok = pairs.some(function(p){ return p[0]===selectedColor && p[1]===opt; });
      if (ok) {
        $(this).prop('disabled', false);
        $('label[for="'+$(this).attr('id')+'"]').removeClass('disabled');
      } else if (opt!==selectedOption) {
        $(this).prop('disabled', true);
        $('label[for="'+$(this).attr('id')+'"]').addClass('disabled');
      }
    });
  }

  else {
    // no sufficient selections
  }

}, 10);

  
});




// -----------------------------------------------------------
// The Jersey Nation - PDP Model Measurements drawer bootstrap
// - Self-contained open/close (does NOT use theme.Drawers) so nothing
//   outside our namespace can accidentally close the drawer.
// - Reveals the trigger only when the Flickity slideshow moves off slide 0.
// -----------------------------------------------------------
(function () {
  function bootMeasurementsDrawer() {
    try {
      var el = document.getElementById('MeasurementsDrawer');
      if (!el) return true; // nothing to do on non-PDP pages
      if (el.getAttribute('data-measurements-drawer-booted') === '1') return true;
      el.setAttribute('data-measurements-drawer-booted', '1');

      var backdrop = document.getElementById('MeasurementsBackdrop');

      // Move drawer + backdrop to <body> so no ancestor stacking context
      // (transform, will-change, filter, contain) can trap our fixed positioning.
      if (backdrop && backdrop.parentNode !== document.body) document.body.appendChild(backdrop);
      if (el.parentNode !== document.body) document.body.appendChild(el);

      function setOpen(open) {
        el.classList.toggle('drawer--is-open', open);
        el.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (backdrop) {
          backdrop.classList.toggle('is-open', open);
          backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
        // NOTE: intentionally NOT toggling html.js-drawer-open — the theme's
        // base CSS renders a full-viewport body:after backdrop when that class
        // is on <html>, which would double-cover our own backdrop with a much
        // darker layer. We lock body scroll via our own class instead.
        document.body.classList.toggle('measurements-drawer-open', open);
        var triggers = document.querySelectorAll('.js-drawer-open-measurements');
        for (var i = 0; i < triggers.length; i++) {
          triggers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
      function open(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        }
        setOpen(true);
      }
      function close(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        }
        setOpen(false);
      }

      // Bind trigger(s) — capture phase so no ancestor listener sees the click.
      var triggers = document.querySelectorAll('.js-drawer-open-measurements');
      for (var i = 0; i < triggers.length; i++) {
        // Remove theme.Drawers style attribute so nothing else auto-hooks it.
        triggers[i].addEventListener('click', open, true);
      }
      // Close button(s) inside the drawer.
      var closers = el.querySelectorAll('.js-drawer-close');
      for (var j = 0; j < closers.length; j++) {
        closers[j].addEventListener('click', close, true);
      }
      // Backdrop click closes.
      if (backdrop) backdrop.addEventListener('click', close, true);
      // Escape closes.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && el.classList.contains('drawer--is-open')) close();
      });

      return true;
    } catch (err) {
      if (window.console && console.warn) console.warn('MeasurementsDrawer boot failed', err);
      return true;
    }
  }

  // Reveal the trigger only when the active slide index is >= 1.
  function bootSlideGate() {
    try {
      var trigger = document.querySelector('.measurements-trigger');
      if (!trigger) return true; // no trigger (no metafield data) — nothing to gate
      if (trigger.getAttribute('data-slide-gate-booted') === '1') return true;

      var slideshow = document.querySelector('.product-slideshow[data-product-photos]');
      if (!slideshow) {
        // Fallback: no slideshow container found — reveal trigger unconditionally.
        trigger.classList.add('is-visible');
        trigger.setAttribute('data-slide-gate-booted', '1');
        return true;
      }

      function reveal(idx) {
        if (typeof idx !== 'number') idx = -1;
        if (idx >= 1) trigger.classList.add('is-visible');
        else trigger.classList.remove('is-visible');
      }

      // Try Flickity native API first.
      var Flkty = window.Flickity || (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity && window.jQuery.fn.flickity.Flickity);
      if (Flkty && typeof Flkty.data === 'function') {
        var flkty = Flkty.data(slideshow);
        if (flkty) {
          reveal(flkty.selectedIndex);
          flkty.on('select', function () { reveal(flkty.selectedIndex); });
          trigger.setAttribute('data-slide-gate-booted', '1');
          return true;
        }
      }
      // Fallback: jQuery Flickity event.
      if (window.jQuery && jQuery(slideshow).data('flickity')) {
        var $s = jQuery(slideshow);
        var fk = $s.data('flickity');
        if (fk) {
          reveal(fk.selectedIndex);
          $s.on('select.flickity', function () { reveal(fk.selectedIndex); });
          trigger.setAttribute('data-slide-gate-booted', '1');
          return true;
        }
      }
      return false; // Flickity not ready — retry
    } catch (err) {
      if (window.console && console.warn) console.warn('SlideGate boot failed', err);
      return true;
    }
  }

  function tryBootWithRetry() {
    var attempts = 0;
    var drawerDone = bootMeasurementsDrawer();
    var gateDone = bootSlideGate();
    if (drawerDone && gateDone) return;
    var iv = setInterval(function () {
      attempts++;
      if (!drawerDone) drawerDone = bootMeasurementsDrawer();
      if (!gateDone) gateDone = bootSlideGate();
      if ((drawerDone && gateDone) || attempts > 40) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBootWithRetry);
  } else {
    tryBootWithRetry();
  }
})();
